import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Copiar } from '@shared/interfaces/request/copiar';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class DuplicarService {
  private _url = environment.apiBaseUrl + 'api/Auditar/';
  constructor(private _http: HttpClient) { }

  duplicar(model: Copiar): Observable<Response> {
    let url: string = this._url + 'Duplicar' ;
    return this._http.post<Response>(url, model, httpOption);
  }
}
